import { defineComponent as _defineComponent } from 'vue'
import { BrandLogosWidgetItem } from 'JS/dxp/types/widgets';
import { computed } from 'vue';
import { cssVarsToStyleString } from 'JS/dxp/utilities/css-vars';
import { first, range } from 'JS/utilities/iterator';
import { pipe } from 'JS/utilities/fp';


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandLogosWidgetStackedLayout',
  props: {
    items: null
  },
  setup(__props: any) {

const props = __props as {
	items: BrandLogosWidgetItem[];
}



const columns = computed(() => {
	const items = props.items.length;
	return ({
		mobile: 3,
		mobileLarge: findIdealNumberOfColumns({ min: 3, max: 4, items }),
		tablet: findIdealNumberOfColumns({ min: 4, max: 5, items }),
		desktop: findIdealNumberOfColumns({ min: 4, max: 6, items }),
	});
});

/**
 * Determines the largest number of columns between min and max which produce a grid with > 1 item
 * in the final row. If no value in the range does, then it opts to maximize the number of columns.
 */
function findIdealNumberOfColumns({ min, max, items }: { min: number; max: number; items: number; }) {
	if (items <= max) {
		return items;
	}

	return pipe(
		range(max, min),
		first(columns => items % columns !== 1),
	) ?? max;
}

/**
 * Given the number of columns, determine how many spaces (in increments of 0.5)
 * orphans must shift from their default grid position in order to be centered
 */
function getSpacesToShiftOrphans(columns: number) {
	const numItems = props.items.length;
	const numOrphans = numItems % columns;

	if (numItems <= columns || numOrphans === 0) {
		return 0;
	}

	return (columns - numOrphans) / 2;
}

/**
 * Returns true if the index is in the last row and the last row's width
 * is less than the number of columns
 */
function isOrphan(index: number, columns: number) {
	const numItems = props.items.length;
	const lastIndexOfEvenRow = numItems - (numItems % columns) - 1;
	return index > lastIndexOfEvenRow;
}

/**
 * Gets the amount we need to shift a specific item. Only orphaned
 * items will shift @see {@link getSpacesToShiftOrphans}. If the
 * item is not an orphan, return undefined to reduce the size of the
 * generated markup
 */
function getSpacesToShiftItem(index: number, columns: number): number | undefined {
	return isOrphan(index, columns)
		? getSpacesToShiftOrphans(columns)
		: undefined;
}


return { __sfc: true,props, columns, findIdealNumberOfColumns, getSpacesToShiftOrphans, isOrphan, getSpacesToShiftItem, cssVarsToStyleString }
}

})